const config = {
    backendUrl: process.env.VUE_APP_BACKEND_URL
};

export default config;